import React from 'react';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { SVGIcon } from '../../../../components/atoms/SVG';

type AccordionItemExtraButtonProps = {
  svgSpriteId: SVGIcon;
  href: string;
  text: string;
};

export function AccordionItemExtraButton({ svgSpriteId, href, text }: AccordionItemExtraButtonProps) {
  return (
    <span className="accordion__icon-edit">
      <ButtonMinorAction icon={svgSpriteId} href={href} text={text} tooltipPlacement={TooltipPlacement.TOP} />
    </span>
  );
}
